import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "2rem",
  },
  paper: {
    // padding: "2rem",
    backgroundColor: "transparent",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "1.5rem",
    color: "#333333",
  },
  tableContainer: {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  table: {
    maxWidth: "100%",
    margin: 0,
  },
  tableHead: {
    backgroundColor: "#f5f5f5",
  },
  tableHeaderCell: {
    fontFamily: "Satoshi-Bold",
    color: "#333333",
    fontSize: "0.875rem",
    padding: "10px 14px",
  },
  tableCell: {
    fontSize: "0.875rem",
    color: "#666666",
    padding: "10px 14px",
  },
  viewButton: {
    textTransform: "none",
    color: "#03697D",
    fontSize: "0.75rem",
    padding: "6px 10px",
    border: "1px solid #03697D",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#03697D",
      color: "#fff",
    },
  },
  buttonIcon: {
    marginLeft: "6px",
    fontSize: "14px",
  },
  emptyMessage: {
    textAlign: "center",
    padding: "2rem",
    color: "#999999",
    fontSize: "14px",
  },
  dateCell: {
    whiteSpace: "nowrap",
  },
  tabContainer: {
    display: "flex",
    gap: "1rem",
    marginBottom: "1.5rem",
    borderBottom: "2px solid #e0e0e0",
  },
  tab: {
    padding: "0.75rem 1.5rem",
    fontSize: "14px",
    fontWeight: 500,
    color: "#666666",
    cursor: "pointer",
    border: "none",
    background: "transparent",
    borderBottom: "3px solid transparent",
    marginBottom: "-2px",
    transition: "all 0.3s ease",
    "&:hover": {
      color: "#333333",
    },
  },
  tabActive: {
    color: "#03697D",
    fontWeight: 600,
    borderBottom: "3px solid #03697D",
  },
}));

export default function RedactedAwards({ analyticsData = [] }) {
  const classes = useStyles();
  const [selectedTag, setSelectedTag] = useState("nsdl");

  // Flatten the array if it's an array of arrays
  const data = Array.isArray(analyticsData)
    ? analyticsData.flat()
    : [];

  // Filter data based on selected tag
  const filteredData = data.filter((item) => {
    const tags = item?.content_tags || [];
    return tags.some((tag) => tag.toLowerCase() === selectedTag.toLowerCase());
  });

  const handleViewPDF = (link) => {
    if (link) {
      window.open(link, "_blank");
    }
  };

  const tags = ["nsdl", "nse"];

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <Typography className={classes.title}>Redacted Awards</Typography>

        {/* Tag Filter Tabs */}
        <Box className={classes.tabContainer}>
          {tags.map((tag) => (
            <button
              key={tag}
              className={`${classes.tab} ${selectedTag === tag ? classes.tabActive : ""}`}
              onClick={() => setSelectedTag(tag)}
            >
              {tag.toUpperCase()}
            </button>
          ))}
        </Box>

        {filteredData && filteredData.length > 0 ? (
          <TableContainer className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell}>Name</TableCell>
                  <TableCell className={`${classes.tableHeaderCell} ${classes.dateCell}`}>Uploaded At</TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell className={classes.tableCell}>
                      {item?.name || "N/A"}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.dateCell}`}>
                      {item?.uploaded_at ? new Date(item.uploaded_at).toLocaleDateString('en-GB') : "N/A"}
                    </TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.dateCell}`} align="center">
                      <Button
                        className={classes.viewButton}
                        onClick={() => handleViewPDF(item?.link)}
                        disabled={!item?.link}
                      >
                        View PDF
                        <OpenInNewIcon className={classes.buttonIcon} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box className={classes.emptyMessage}>
            No redacted awards available
          </Box>
        )}
      </Paper>
    </Box>
  );
}
